// Environment configuration
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
  nodeEnv: import.meta.env.VITE_NODE_ENV || 'development',
  isDevelopment: import.meta.env.VITE_NODE_ENV === 'development',
  isProduction: import.meta.env.VITE_NODE_ENV === 'production'
}

// Export API_BASE_URL for convenience
export const API_BASE_URL = config.apiBaseUrl

// API endpoints (sin prefijo /api ya que está en VITE_API_BASE_URL)
export const endpoints = {
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    profile: '/auth/profile',
    register: '/auth/register',
    changePassword: '/auth/change-password'
  },
  users: {
    list: '/users',
    detail: '/users', // /users/:id
    create: '/users',
    update: '/users', // /users/:id
    delete: '/users'  // /users/:id
  },
  // Aquí puedes agregar más endpoints cuando los tengas
  markets: {
    stocks: '/markets/stocks',
    indices: '/markets/indices'
  },
  jobRequests: {
    list: '/job-requests',
    detail: '/job-requests', // /job-requests/:id
    create: '/job-requests',
    update: '/job-requests', // /job-requests/:id
    delete: '/job-requests', // /job-requests/:id
    myRequests: '/job-requests/my-requests',
    statistics: '/job-requests/statistics'
  },
  audit: {
    userHistory: '/audit/user', // /audit/user/:userId
    recent: '/audit/recent',
    filtered: '/audit'
  },
  catalogs: {
    base: '/catalogos'
  },
  rbac: {
    roles: '/roles',
    systemRoles: '/roles/system',
    permissions: '/permissions',
    userRoles: '/users', // /users/:id/roles
    userPermissions: '/users', // /users/:id/permissions
    userRbacSummary: '/users' // /users/:id/rbac-summary
  },
  dashboard: {
    metrics: '/dashboard/metrics'
  },
  systemSettings: {
    base: '/admin/system-settings'
  },
  candidates: {
    register: '/candidato/registro',
    profile: '/candidates/profile' // /:id
  },
  hrInterviews: {
    base: '/candidates/hr-interview',
    results: '/candidates/hr-interview', // /:id/results
    uploadTest: '/candidates/hr-interview', // /:id/upload-test
    byCandidate: '/candidates/hr-interview/candidate', // /:candidateId
    interviewers: '/candidates/hr-interview/interviewers'
  },
  menu: {
    userMenu: '/menu-items/user/me',
    list: '/menu-items',
    detail: '/menu-items', // /:id
    create: '/menu-items',
    update: '/menu-items', // /:id
    delete: '/menu-items', // /:id
    assignToRole: '/menu-items/roles', // /:roleId/assign
    getRoleMenu: '/menu-items/roles', // /:roleId
    removeFromRole: '/menu-items/roles', // /:roleId/remove
    assignToModule: '/menu-items/modules', // /:moduleId/assign
    getModuleMenu: '/menu-items/modules', // /:moduleId
    removeFromModule: '/menu-items/modules' // /:moduleId/remove
  }
}
